module.exports = __webpack_public_path__ + "img/fcmd1.b64b5430.jpg";